import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="py-10 border-y border-white/10 bg-[#0c100e] overflow-hidden">
      <Marquee speed={35} gradient={false} autoFill>
        {t.marquee.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-4xl sm:text-5xl lg:text-6xl text-[#f0f4f2]/90 px-8">{w}</span>
            <span className="text-[#c5a059] text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
